"use client";

import { useState } from "react";

import { cn } from "@/lib/utils";

import ImageSlider from "../image-slider/image-slider";
import { TutorialStep } from "./tutorial-section";

export type TutorialSliderProps = {
  steps: TutorialStep[];
  stepLabelTemplate?: string;
};

export default function TutorialSlider({ steps, stepLabelTemplate = "Step {n}:" }: TutorialSliderProps) {
  const [activeStepIndex, setActiveStepIndex] = useState(0);

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 items-center gap-10">
      <ImageSlider activeIndex={activeStepIndex} images={steps.map(step => step.image)} onChange={index => setActiveStepIndex(index)} />
      <div className="space-y-6">
        {steps.map((step, index) => (
          <div
            key={index}
            role="button"
            tabIndex={0}
            onClick={() => setActiveStepIndex(index)}
            onKeyDown={e => {
              if (e.key === "Enter" || e.key === " ") setActiveStepIndex(index);
            }}
            className={cn(
              "flex flex-col items-center lg:items-start gap-y-2 cursor-pointer border-b-4 border-transparent pb-2 outline-none focus-visible:outline-primary",
              activeStepIndex === index && "border-primary"
            )}
          >
            <h3 className={cn("text-xl text-center lg:text-start", activeStepIndex === index && "text-primary")}>
              <span className="font-bold underline underline-offset-2">{stepLabelTemplate.replace("{n}", String(index + 1))}</span>{" "}
              {step.title}
            </h3>
            <p className="max-w-xl lg:text-lg text-center lg:text-start text-balance text-gray-600">{step.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
